export default {
    one_subsea_tld: 'OneSubsea TLD HD',
    one_subsea_tld_mux: 'OneSubsea TLD MUX',
    one_subsea_global: 'OneSubsea Global HD 10K',
    one_subsea_global_5k: 'OneSubsea Global 5K',
    one_subsea_leeds: 'OneSubsea Leeds MUX',
    one_subsea_pre_salt: 'OneSubsea Pré-Sal MUX',
    one_subsea_plangas: 'OneSubsea Plangás DLL GLL 2000m',
    one_subsea_plangas_da_gl: 'OneSubsea Plangás DA GL 300m',
    aker_pre_salt: 'Aker Pré-sal MUX',
    aker_lula: 'Aker Piloto de Lula MUX',
    fmc_pre_salt: 'FMC Pré-sal MUX',
    anm_global_hd: 'ANM Global HD 5k',
    aker_60xmt_10k: 'Aker 60XMT GLL/DL HP/HT 10K',
    ge_piggy_back_gll: 'GE Vertical de Injeção de Água em Piggy Back GLL 5K',
    cameron_gll_dll: 'Cameron de Produção GLL/DLL 2500M 10K',
    cameron_gll_cvd: 'Cameron Sidon ANMH DL GLL CVD'
}
